import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { Problem } from 'src/app/models/problem';
import { MenuItem } from 'src/app/state-management';

@Component({
    selector: 'app-dashboard-nav',
    templateUrl: './dashboard-nav.component.html',
    styleUrls: ['./dashboard-nav.component.scss'],
    standalone: false
})

export class DashboardNavComponent implements OnInit, OnChanges {
  @ViewChild('list') listView: ElementRef;
  @ViewChild('maplist') maplistView: ElementRef;
  @ViewChild('map') mapView: ElementRef;

  @Output() viewSelected = new EventEmitter<string>();
  @Input() dashboardView: string;
  @Output() downloadEmitter = new EventEmitter<null>();
  @Output() saveDashboardViewEmitter = new EventEmitter<string>();
  @Output() clearFiltersEmitter = new EventEmitter<null>();

  @Output() linkProblemsToggleEmitter = new EventEmitter<boolean>();
  @Output() openLinkProblemsEmitter = new EventEmitter<null>();
  @Input() selectedProblemsToLink: Problem[];
  @Input() menuItems: MenuItem;
  @Input() isRecentsView: boolean;

  linkCaseToggleClicked = false;
  headerText = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.isRecentsView) {
      this.headerText = `Recently Viewed`;
    } else {
      if (!!this.menuItems.currentUser) {
        this.headerText = `${this.menuItems.currentUser.firstName}'s Dashboard`;
      }
    }
  }

  selectView(viewItem: string) {
    this.viewSelected.emit(viewItem);
  }

  onDownloadClick() {
    this.downloadEmitter.emit();
  }

  onSaveDefaultViewClick() {
    this.saveDashboardViewEmitter.emit(this.dashboardView);
  }

  onClearFiltersClick() {
    this.clearFiltersEmitter.emit();
  }

  onToggleLinkProblems() {
    this.linkCaseToggleClicked = !this.linkCaseToggleClicked;
    this.linkProblemsToggleEmitter.emit(this.linkCaseToggleClicked);
  }

  onOpenLinkProblemsPrompt() {
    this.openLinkProblemsEmitter.emit();
  }

}
